export const styles = () => ({
  link: {
    color: '#1658F3',
    fontWeight: 'normal',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: 200,
    whiteSpace: 'nowrap',
    display: 'inline-block',
  },
  copyIcon: {
    display: 'inline-block',
    marginLeft: 6,
    cursor: 'pointer',
  },
  linkWrap: {
    display: 'flex',
  },
})
